import Emitter from './emitter';

export default {
  mixins: [
    Emitter,
  ],
  watch: {
    curValue(value, oldValue) {
      // 值发生改变
      if (JSON.stringify(oldValue) !== JSON.stringify(value)) {
        /**
         * 双向绑定
         *
         * @event input
         */
        this.$emit('input', value);

        // 触发form中的change事件
        this.dispatch('ten-form-item', 'form.change', value);
      }
    },
  },
};
